class SlumberSliderAutoplay {
  constructor(root) {
    this.root = root;
    this.slider = root.querySelector('[id^="Slider-"]');

    if (!this.slider || root.dataset.slumberAutoplay !== 'true') return;

    this.speed = (parseInt(root.dataset.slumberAutoplaySpeed, 10) || 5) * 1000;
    this.isAutoScrolling = false;
    this.timer = null;
    this.slides = [];
    this.sliderItemOffset = 0;
    this.maxScroll = 0;

    this.onMouseEnter = () => this.pause();
    this.onMouseLeave = () => this.play();
    this.onFocusIn = () => this.pause();
    this.onFocusOut = (event) => {
      if (!this.root.contains(event.relatedTarget)) this.play();
    };
    this.onVisibilityChange = () => {
      document.hidden ? this.pause() : this.play();
    };
    this.onScroll = () => {
      if (this.isAutoScrolling) return;
      this.play();
    };
    this.onNavClick = () => this.play();
    this.onTouchStart = () => this.pause();
    this.onTouchEnd = () => this.play();

    this.root.addEventListener('mouseenter', this.onMouseEnter);
    this.root.addEventListener('mouseleave', this.onMouseLeave);
    this.root.addEventListener('focusin', this.onFocusIn);
    this.root.addEventListener('focusout', this.onFocusOut);
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    this.slider.addEventListener('scroll', this.onScroll, { passive: true });
    this.slider.addEventListener('touchstart', this.onTouchStart, { passive: true });
    this.slider.addEventListener('touchend', this.onTouchEnd, { passive: true });
    this.slider.addEventListener('touchcancel', this.onTouchEnd, { passive: true });

    this.root.querySelectorAll('button[name="previous"], button[name="next"]').forEach((button) => {
      button.addEventListener('click', this.onNavClick);
    });

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.updateMetrics());
      this.resizeObserver.observe(this.slider);
    }

    this.updateMetrics();
    this.play();
  }

  destroy() {
    this.pause();
    this.root.removeEventListener('mouseenter', this.onMouseEnter);
    this.root.removeEventListener('mouseleave', this.onMouseLeave);
    this.root.removeEventListener('focusin', this.onFocusIn);
    this.root.removeEventListener('focusout', this.onFocusOut);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    this.slider?.removeEventListener('scroll', this.onScroll);
    this.slider?.removeEventListener('touchstart', this.onTouchStart);
    this.slider?.removeEventListener('touchend', this.onTouchEnd);
    this.slider?.removeEventListener('touchcancel', this.onTouchEnd);
    this.resizeObserver?.disconnect();
  }

  updateMetrics() {
    this.slides = Array.from(this.slider.querySelectorAll('[id^="Slide-"]')).filter(
      (slide) => slide.clientWidth > 0
    );

    if (this.slides.length < 2) {
      this.pause();
      return;
    }

    this.sliderItemOffset = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
    this.maxScroll = Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);
  }

  play() {
    if (this.slides.length < 2 || this.maxScroll <= 0) return;

    this.pause();
    this.timer = setInterval(() => this.advance(), this.speed);
  }

  pause() {
    clearInterval(this.timer);
    this.timer = null;
  }

  advance() {
    const tolerance = 4;
    const scrollLeft = this.slider.scrollLeft;
    const atEnd = scrollLeft >= this.maxScroll - tolerance;
    let target = 0;

    const reviewsNav = this.root._slumberReviewsNav;

    if (reviewsNav?.step) {
      const activeIndex = reviewsNav.getActiveIndex();

      if (activeIndex >= reviewsNav.maxIndex) {
        target = 0;
      } else {
        target = (activeIndex + 1) * reviewsNav.step;
      }
    } else if (atEnd) {
      target = 0;
    } else {
      const nextSlide = this.slides.find((slide) => slide.offsetLeft > scrollLeft + tolerance);
      target = nextSlide ? nextSlide.offsetLeft : this.maxScroll;
    }

    this.isAutoScrolling = true;
    this.slider.scrollTo({ left: target, behavior: 'smooth' });

    window.setTimeout(() => {
      this.isAutoScrolling = false;
    }, 400);
  }
}

function initSlumberSliderAutoplay(root = document) {
  root.querySelectorAll('slider-component[data-slumber-autoplay="true"]').forEach((element) => {
    if (element._slumberAutoplay) {
      element._slumberAutoplay.destroy();
    }

    element._slumberAutoplay = new SlumberSliderAutoplay(element);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initSlumberSliderAutoplay());
} else {
  initSlumberSliderAutoplay();
}

document.addEventListener('shopify:section:load', (event) => {
  initSlumberSliderAutoplay(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('slider-component[data-slumber-autoplay="true"]').forEach((element) => {
    element._slumberAutoplay?.destroy();
    delete element._slumberAutoplay;
  });
});
